import useCreateJobContextValue from 'pages/CreateJob/CreateJob-useCreateJobContextValue';
import {
  BANK_PAYMENT_OPTION,
  MANUAL_PAYMENT_OPTION,
} from './PaymentOptions-constants';

const ContainerComponent = ({ children }) => {
  const { data } = useCreateJobContextValue();

  const checkoutOptions = data?.job?.checkout_options;

  const showManualPaymentOption =
    checkoutOptions && checkoutOptions?.includes('pay_on_completion');

  const showBankPaymentOption = false;

  const options = [
    showManualPaymentOption && MANUAL_PAYMENT_OPTION,
    showBankPaymentOption && BANK_PAYMENT_OPTION,
  ].filter(Boolean);

  return children({
    options,
  });
};

ContainerComponent.displayName =
  'PaymentMethods-Desktop-PaymentOptions-container';

export default ContainerComponent;
